<template>
    <div class="title">
        <h2>
            <div v-show="project.name" @click.stop="setProjectList(!project.show)">
                <span>{{project.name}}</span>
                <YD-image :src="project.show?'icon/icon_下拉箭头_黑色_向上':'icon/icon_下拉箭头_黑色_向下'"></YD-image>
            </div>
            <div id="title_list" v-show="project.name && project.show">
                <div class="title_list_content">
                    <ul>
                        <li v-for="(item,index) in projectData" :key="index">
                            <div class="name" v-pressed 
                                v-if="item.Children && item.Children.length > 0" 
                                :class="{'childrenActive':project.activeIndex == index}"
                                @click.stop="selectProject(0,index,item.Id,item.Name,item.Children)"
                            >{{item.Name}}</div>
                            <div class="name" v-pressed 
                                v-else
                                :class="{'active':project.activeIndex == index}"
                                @click.stop="selectProject(0,index,item.Id,item.Name)"
                            >{{item.Name}}</div>
                            <ol
                                v-if="item.Children && item.Children.length > 0" 
                                v-show="project.activeIndex == index"
                            >
                                <li v-pressed 
                                    v-for="(subItem,subIndex) in item.Children" :key="subIndex"
                                    :class="{'active':project.CActiveIndex == subIndex}"
                                    @click.stop="selectProject(1,subIndex,subItem.Id,subItem.Name)"
                                >{{subItem.Name}}</li>
                            </ol>
                        </li>
                    </ul>
                </div>
                <div class="cover"></div>
            </div>
        </h2>
        <slot><p class="subTitle">{{subTitle}}</p></slot>
    </div>
</template>
<script>
export default {
    props:{
        projectData:{
            type:Array,
            required: true,
            default:()=>[]
        },
        subTitle:String,
        Id:{
            type:Number,
            default:-1
        },
        hide:Boolean
    },
    data(){
        return {
            project:{
                show:false,
                Id:-1,
                name:'',
                oldIndex: -1,//未点击子选项前标记前一个大项的下标
                COldIndex: -1,//未点击子选项前标记前一个小项
                activeIndex:-1,//父选中
                CActiveIndex:-1,//子选中
            },
            step:0,
        }
    },
    watch:{
        Id:function(newVal){
            if(newVal != this.project.Id){
                this.setProjectActive();
            }
        },
        projectData:function(){
            this.setProjectActive();
            this.$emit('init',this.project.Id);
        },
        hide:function(){
            if(typeof this.hide == 'boolean'){
                if(this.hide){
                    this.setProjectList(false);
                }
            }
        }
    },
    mounted() {
        var _this = this;
        window.addEventListener('click',function(){
            _this.setProjectList(false);
        })
        var dblclickTimer = null, dblclick = false;
        this.$el.addEventListener('click',function(){
            clearTimeout(dblclickTimer);
            if(dblclick){
                clearTimeout(dblclickTimer);
                dblclick = false;
                _this.$emit('dblclick')
            }else{
                dblclick = true;
                dblclickTimer = setTimeout(() => {
                    clearTimeout(dblclickTimer);
                    dblclick = false;
                }, 300);
            }
        })
    },
    destroy(){
        window.removeEventListener('click');
    },
    methods:{
        setProjectActive(){
            var arr = this.projectData;
            var obj = this.project;
            if(arr.length > 0){
                var is = true;
                i:
                for(var i=0;i<arr.length;i++){
                    if(arr[i].Children && arr[i].Children.length > 0){
                        let Children = arr[i].Children;
                        for(var j=0;j<Children.length;j++){
                            if(this.Id == Children[j].Id){
                                obj.activeIndex = i;
                                obj.CActiveIndex = j;
                                obj.name = Children[j].Name;
                                obj.Id = Children[j].Id;
                                is = false;
                                break i;
                            }
                        }
                    }else if(this.Id == arr[i].Id){
                        obj.activeIndex = i;
                        obj.CActiveIndex = -1;
                        obj.name = arr[i].Name;
                        obj.Id = arr[i].Id;
                        is = false;
                        break ;
                    }
                }
                if(is){
                    obj.activeIndex = 0;
                    if(arr[0].Children && arr[0].Children.length > 0){
                        obj.CActiveIndex = 0;
                        obj.name = arr[0].Children[0].Name;
                        obj.Id = arr[0].Children[0].Id;
                    }else{
                        obj.CActiveIndex = -1;
                        obj.name = arr[0].Name;
                        obj.Id = arr[0].Id;
                    }
                }
            }
        },
        setProjectList(show){
            var obj = this.project;
            if(obj.show && obj.oldIndex != -1){
                obj.activeIndex = obj.oldIndex;
                obj.CActiveIndex = obj.COldIndex;
                obj.oldIndex = -1;
                obj.COldIndex = -1;
            }
            obj.show = show;
            if(show){
                this.$emit('show');
            }
        },
        selectProject(type,index,id,name,children){
            var obj = this.project;
            var isSelect = false;
            if(type == 0){
                if(obj.activeIndex != index){
                    if(children && children.length > 0){
                        obj.oldIndex = obj.activeIndex;
                        obj.COldIndex = obj.CActiveIndex;
                    }else{
                        isSelect = true;
                    }
                    obj.activeIndex = index;
                    obj.CActiveIndex = -1;
                }
            }else{
                obj.CActiveIndex = index;
                isSelect = true;
            }
            if(isSelect){
                obj.name = name;
                obj.Id = id;
                obj.oldIndex = -1;
                obj.COldIndex = -1;
                obj.show = false;
                this.$emit('change',id)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@assets/scss/ProjectSelectTitle.scss";
</style>